/**
 * Remote control settings plugin.
 */

'use strict';

/* eslint max-lines-per-function: 0 */
/* eslint quote-props: 0 */

var gettextWrapper = require('mag-gettext'),
    links = require('./links'),
    ids = require('./ids'),

    renders, gettext;


function buildIGMP ( data ) {
    var getter = links.api.getters.environment,
        saver = links.api.savers.environment;

    data.options.push(
        {
            id: ids.igmp,
            name: gettext('IGMP version'),
            description: '',
            icon: 'theme-icon-globe',
            render: renders.popupSelect,
            title: gettext('Select IGMP version'),
            saveImmediate: true,
            environment: {
                'igmp_conf': ''
            },
            prepareForRender: function ( environment, callback ) {
                var options = [
                    {name: 'V2', value: 'V2', selected: environment['igmp_conf'] === 'V2'},
                    {name: 'V3', value: 'V3', selected: environment['igmp_conf'] === 'V3'}
                ];

                callback(options);
            },
            prepareForSave: function ( value, callback ) {
                this.environment['igmp_conf'] = value;
                callback();
            },
            getter: getter,
            saver: saver,
            type: 'option',
            parent: ids.base
        }
    );
}


function buildList () {
    var buildEthernet = require('./build.ethernet'),
        buildPPPoE = require('./build.pppoe'),
        buildWiFi = require('./build.wifi'),
        buildMulticast = require('./build.multicast'),
        buildInfo = require('./build.info'),
        data = {
            id: ids.base,
            name: gettext('Network'),
            description: gettext('Configuring network connection settings'),
            icon: 'theme-icon-network',
            sections: [],
            options: [],
            content: []
        };

    buildEthernet(data);

    switch ( core.device.model ) {
        case 'MAG324':
        case 'MAG325':
        case 'MAG349':
        case 'MAG350':
        case 'MAG351':
        case 'MAG352':
        case 'MAG256':
        case 'MAG257':
            buildWiFi(data);
            buildMulticast(data);
            buildIGMP(data);
            buildInfo(data);
            break;
        case 'emulator':
        case 'emulator_stb':
        case 'AndroidSTB':
        case 'AndroidAPP':
            buildWiFi(data);
            buildMulticast(data);
            buildInfo(data);
            break;
        default:
            buildPPPoE(data);
            buildWiFi(data);
            buildMulticast(data);
            buildIGMP(data);
            buildInfo(data);
            break;
    }

    return data;
}


module.exports = {
    onSettingsInit: function ( config, callback ) {
        links.api = config.api;
        renders = links.api.renders;

        gettextWrapper.load({
            name: core.environment.language,
            path: config.path + 'lang'
        }, function () {
            gettext = links.gettext = gettextWrapper.gettext;
            callback(null, buildList());
        });
    }
};
